import { Page } from "@/models/page-models/Page";

export const CreateCreditNote: Page = {
  "path": "create-credit-note",
  "name": "Create Credit Note",
  "props": {
    "data": {
      "title": "Create Credit Note",
      "printable": "FALSE",
      "url": "create-credit-note",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.type",
                  "label": "Type of Credit Note",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "name": "resetForm"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "[{\"text\":\"Special Discount\",\"value\":\"Discount\"},{\"text\":\"Volume Rebate\",\"value\":\"Volume Rebate\"},{\"text\":\"Cancelled Invoice\",\"value\":\"Cancelled Invoice\"},{\"text\":\"Return Item\",\"value\":\"Return Item\"}]",
                  "itemText": "text",
                  "itemValue": "value",
                  "dropdownType": "static"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedCustomer",
                  "label": "Select Customer",
                  "onVarUpdate": [
                    {
                      "executionOrder": 2,
                      "name": "copyCustomerDetails"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "pushCustomerId",
                        "type": "fnPushToArray",
                        "arg1Key": "sourceVariable",
                        "arg1Value": "fetchedData.selectedCustomer",
                        "arg2Key": "destinationVariable",
                        "arg2Value": "fetchedData.invoiceSearch.q.customer"
                      },
                      "name": "pushCustomerId"
                    },
                    {
                      "executionOrder": 3,
                      "pageFunction": {
                        "name": "copyVatPercentage",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getVatPercentage",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData",
                        "arg3Key": "append",
                        "arg3Value": "TRUE",
                        "arg4Key": "destinationKeyType",
                        "arg4Value": "Object"
                      },
                      "name": "copyVatPercentage"
                    },
                    {
                      "executionOrder": 3,
                      "pageFunction": {
                        "name": "getInvoicesByCustomer",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/invoice/search",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.allInvoices",
                        "arg3Key": "postData",
                        "arg3Value": "fetchedData.invoiceSearch"
                      },
                      "name": "getInvoicesByCustomer"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.type}}",
                  "items": "fetchedData.customers.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,customerAlias,{{__item}})"
                }
              ]
            },
            {
              "name": "3a",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.value",
                  "label": "Value (Excluding VAT)",
                  "unit": "SAR",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),==,'Discount'),&&,fn(LOGICAL,{{fetchedData.selectedCustomer}},>,0))"
                }
              ]
            },
            {
              "name": "3b",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Select Date Range to load Total Invoice Value during the period"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),==,'Volume Rebate'),&&,fn(LOGICAL,{{fetchedData.selectedCustomer}},>,0))"
            },
            {
              "name": "4b",
              "pageItems": [
                {
                  "type": "datepicker",
                  "variable": "fetchedData.startDate",
                  "label": "Start Date",
                  "disabled": "FALSE"
                },
                {
                  "type": "datepicker",
                  "variable": "fetchedData.endDate",
                  "label": "End Date",
                  "disabled": "FALSE"
                },
                {
                  "type": "button",
                  "label": "Load",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "loadStatement"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "secondary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),==,'Volume Rebate'),&&,fn(LOGICAL,{{fetchedData.selectedCustomer}},>,0))"
            },
            {
              "name": "5b",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Total Sales",
                  "disabled": "FALSE",
                  "items": "fetchedData.totalInvoiceValues",
                  "headers": [
                    {
                      "value": "value",
                      "text": "Value",
                      "formula": "fn(HELPER_FN,currency,{{__item.value}})"
                    },
                    {
                      "value": "vat",
                      "text": "VAT",
                      "formula": "fn(HELPER_FN,currency,{{__item.vat}})"
                    },
                    {
                      "value": "total",
                      "text": "Total",
                      "formula": "fn(HELPER_FN,currency,{{__item.total}})"
                    }
                  ],
                  "tableType": "static"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),==,'Volume Rebate'),&&,fn(LOGICAL,{{fetchedData.selectedCustomer}},>,0))"
            },
            {
              "name": "6b",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.percent",
                  "label": "Rebate Percentage",
                  "unit": "%",
                  "disabled": "FALSE",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "name": "updateCreditNoteValue"
                    }
                  ]
                },
                {
                  "type": "input",
                  "variable": "fetchedData.value",
                  "label": "Value (Excluding VAT)",
                  "unit": "SAR",
                  "disabled": "FALSE"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),==,'Volume Rebate'),&&,fn(LOGICAL,{{fetchedData.selectedCustomer}},>,0))"
            },
            {
              "name": "3d",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.reason",
                  "label": "Reasons for issuance of credit note (as per Article 40 (paragraph 1) and Article 54 (3) of KSA VAT regulations)",
                  "disabled": "FALSE",
                  "items": "fetchedData.creditNoteReasons.data.0.data",
                  "itemText": "en",
                  "itemValue": "en",
                  "formula": "{{__item.en}} / {{__item.ar}}"
                },
                {
                  "type": "fileupload",
                  "variable": "formData.additionalProof",
                  "label": "Upload Proof",
                  "disabled": "FALSE",
                  "color": "primary",
                  "previewType": "no-preview"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),==,'Return Item'),&&,fn(LOGICAL,{{fetchedData.selectedCustomer}},>,0))"
            },
            {
              "name": "3c4d",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedInvoice",
                  "label": "Select Invoice",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "getInvoiceDetails",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v2/invoice/{{fetchedData.selectedInvoice}}",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.invoiceDetails"
                      },
                      "name": "getInvoiceDetails",
                      "executeIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),!==,'Volume Rebate'),&&,fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),!==,'Discount'))"
                    },
                    {
                      "executionOrder":2,
                      "pageFunction": {
                        "name": "copyFormattedOrdersForReturnItem",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getFormattedOrdersForReturnItem",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData",
                        "arg3Key": "append",
                        "arg3Value": "TRUE",
                        "arg4Key": "destinationKeyType",
                        "arg4Value": "Object"
                      },
                      "name":"copyFormattedOrdersForReturnItem",
                      "executeIf":"fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),==,'Return Item')"
                    },
                    {
                      "executionOrder":2,
                      "pageFunction": {
                        "name": "copyFormattedOrders",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getFormattedOrders",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData",
                        "arg3Key": "append",
                        "arg3Value": "TRUE",
                        "arg4Key": "destinationKeyType",
                        "arg4Value": "Object"
                      },
                      "name":"copyFormattedOrders",
                      "executeIf":"fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),==,'Cancelled Invoice')"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,{{fetchedData.selectedCustomer}},>,0)",
                  "items": "fetchedData.allInvoices.data.docs",
                  "itemText": "_id",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,invoiceDescription,{{__item}})",
                  "dropdownType": "search",
                  "searchFunctions": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyInvoiceSearchId",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.invoiceSearch.q._id"
                      },
                      "name": "copyInvoiceSearchId"
                    },
                    {
                      "executionOrder": 3,
                      "pageFunction": {
                        "name": "getInvoicesByCustomer",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/invoice/search",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.allInvoices",
                        "arg3Key": "postData",
                        "arg3Value": "fetchedData.invoiceSearch"
                      },
                      "name": "getInvoicesByCustomer"
                    }
                  ]
                }
              ]
            },
            {
              "name": "4abc",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.reason",
                  "label": "Reasons for issuance of credit note (as per Article 40 (paragraph 1) and Article 54 (3) of KSA VAT regulations)",
                  "disabled": "FALSE",
                  "items": "fetchedData.creditNoteReasons.data.0.data",
                  "itemText": "en",
                  "itemValue": "en",
                  "formula": "{{__item.en}} / {{__item.ar}}"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),!==,'Return Item'),&&,fn(LOGICAL,{{fetchedData.selectedCustomer}},>,0))"
            },
            {
              "name": "4abc",
              "pageItems": [
                {
                  "type": "fileupload",
                  "variable": "formData.additionalProof",
                  "label": "Additional Proof",
                  "disabled": "FALSE",
                  "color": "primary",
                  "previewType": "no-preview"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),!==,'Return Item'),&&,fn(LOGICAL,{{fetchedData.selectedCustomer}},>,0))"
            },
            {
              "name": "4d-orders",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedOrderId",
                  "label": "Select Product",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "name": "copySelectedOrder"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.invOrdersForReturn",
                  "itemText": "id.product.alias",
                  "itemValue": "id._id",
                  "formula": "fn(CONCAT,{{__item.id.product._id}}, ,fn(HELPER_FN,productAlias,{{__item.id.product}}))"
                },
                {
                  "type": "button",
                  "label": "Add Item For Return",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "pushSelectedOrder"
                    }
                  ],
                  "disabled": "fn(CONDITIONAL,fn(LOGICAL,{{fetchedData.selectedOrderId}},>,0),false,true)",
                  "color": "secondary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(LENGTH,{{fetchedData.invOrdersForReturn}}),>,0),&&,fn(LOGICAL,fn(LENGTH,{{fetchedData.invoiceDetails.data.orders}}),>,0))"
            },
            {
              "name": "4d-calloffs",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedOrderId",
                  "label": "Select Product",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "name": "copySelectedOrder"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.invOrdersForReturn",
                  "itemText": "callOff.product.alias",
                  "itemValue": "callOff._id",
                  "formula": "fn(CONCAT,{{__item.callOff.product._id}}, ,fn(HELPER_FN,productAlias,{{__item.callOff.product}}))"
                },
                {
                  "type": "button",
                  "label": "Add Item For Return",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "pushSelectedCalloffOrder"
                    }
                  ],
                  "disabled": "fn(CONDITIONAL,fn(LOGICAL,{{fetchedData.selectedOrderId}},>,0),false,true)",
                  "color": "secondary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(LENGTH,{{fetchedData.invOrdersForReturn}}),>,0),&&,fn(LOGICAL,fn(LENGTH,{{fetchedData.invoiceDetails.data.callOffs}}),>,0))"
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Credit Note Preview",
                  "showIf": "fn(LOGICAL,fn(LOGICAL,fn(LOGICAL,fn(LENGTH,{{fetchedData.formattedOrders}}),>,0),||,fn(LOGICAL,fn(LENGTH,{{fetchedData.invOrdersForReturn}}),>,0)),||,fn(LOGICAL,{{fetchedData.value}},>,0))",
                  "class": "text-h5"
                }
              ]
            },
            {
              "name": "6ab",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Discount/VR CN Preview",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,{{fetchedData.value}},>,0)",
                  "items": "fetchedData.orders",
                  "headers": [
                    {
                      "value": "__key",
                      "text": "#",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(SUM,{{__item.__key}},1),/,fn(LENGTH,{{fetchedData.orders}}))"
                    },
                    {
                      "value": "order",
                      "text": "Order #\\n# حزمة",
                      "type": "formula",
                      "formula": "N/A"
                    },
                    {
                      "value": "__item.id.product",
                      "text": "Description\\nالتفاصيل",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(TRANSLATE,{{fetchedData.type}},en),\\n,fn(TRANSLATE,{{fetchedData.type}},ar))",
                      "width": 130
                    },
                    {
                      "value": "__item.id.product.unit.unit2",
                      "text": "Unit\\nالوحدة",
                      "type": "formula",
                      "formula": "N/A"
                    },
                    {
                      "value": "__item.quantity",
                      "text": "Quantity\\nالكمية",
                      "type": "formula",
                      "formula": "N/A"
                    },
                    {
                      "value": "__item.unitPrice",
                      "text": "Unit Price SAR\\nسعر الوحدة  ر س",
                      "type": "formula",
                      "formula": "N/A"
                    },
                    {
                      "value": "__item.value",
                      "text": "Sub Total\\nالمجموع الفرعي",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,{{fetchedData.value}})",
                      "align": "center"
                    },
                    {
                      "value": "vatRate",
                      "text": "VAT %\\nالضريبة %",
                      "type": "formula",
                      "formula": "{{fetchedData.vatPercent}} %"
                    },
                    {
                      "value": "vatValue",
                      "text": "VAT Value\\nقيمة الضريبة",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{fetchedData.value}},{{fetchedData.vatPercent}},0.01))"
                    },
                    {
                      "value": "total",
                      "text": "Total + VAT\\nالمجموع + الضريبة",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,{{__item.fn(MULTIPLY,{{fetchedData.value}},fn(SUM,100,{{fetchedData.vatPercent}}),0.01)}})"
                    }
                  ],
                  "tableType": "static",
                  "showActions": false,
                  "footer": {
                    "value": "{{fetchedData.selectedInvoice.data.orders.0.additionalCharges}}",
                    "id.product": "{{fetchedData.selectedInvoice.data.orders.0.additionalChargesType}}"
                  },
                  "hideFooter": "fn(LOGICAL,{{fetchedData.selectedInvoice.data.orders.0.additionalCharges}},>,0)"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),==,'Discount'),||,fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),==,'Volume Rebate'))"
            },
            {
              "name": "6c",
              "pageItems": [
                {
                  "type": "table",
                  "label": "CN Cancelled Preview",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),==,'Cancelled Invoice'),&&,fn(LOGICAL,fn(LENGTH,{{fetchedData.formattedOrders}}),>,0))",
                  "items": "fetchedData.formattedOrders",
                  "headers": [
                    {
                      "value": "slNo",
                      "text": "#",
                      "width": 41
                    },
                    {
                      "value": "order",
                      "text": "Order #\\n# حزمة"
                    },
                    {
                      "value": "description",
                      "text": "Description\\nالتفاصيل",
                      "width": 175
                    },
                    {
                      "value": "unit",
                      "text": "Unit\\nالوحدة",
                      "width": 66
                    },
                    {
                      "value": "quantity",
                      "text": "Quantity\\nالكمية"
                    },
                    {
                      "value": "unitPrice",
                      "text": "Price\\nالسعر"
                    },
                    {
                      "value": "subTotal",
                      "text": "Sub Total\\nالمجموع الفرعي"
                    },
                    {
                      "value": "vatRate",
                      "text": "VAT %\\nالضريبة %"
                    },
                    {
                      "value": "vatValue",
                      "text": "VAT Value\\nقيمة الضريبة",
                      "width": 100
                    },
                    {
                      "value": "total",
                      "text": "Total + VAT\\nالمجموع + الضريبة"
                    }
                  ],
                  "tableType": "static",
                  "showActions": false,
                  "fontSize": "0.75rem;"
                }
              ]
            },
            {
              "name": "6d-orders",
              "pageItems": [
                {
                  "type": "table",
                  "variable": "fetchedData.returnedOrders",
                  "label": "CN preview MR",
                  "disabled": "FALSE",
                  "items": "fetchedData.invOrdersForReturn",
                  "showIf": "fn(LOGICAL,fn(LENGTH,{{fetchedData.invoiceDetails.data.orders}}),>,0)",
                  "headers": [
                    {
                      "value": "__key",
                      "text": "#",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(SUM,{{__item.__key}},1),/,fn(LENGTH,{{fetchedData.returnedOrders}}))"
                    },
                    {
                      "value": "__item.id._id",
                      "text": "Order #\\n# حزمة",
                      "type": "formula",
                      "formula": "{{__item.id.product._id}}\\n{{__item.id._id}}"
                    },
                    {
                      "value": "__item.id.product.alias",
                      "text": "Description\\nالتفاصيل",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,productAlias,{{__item.id.product}})"
                    },
                    {
                      "value": "__item.id.product",
                      "text": "Unit\\nالوحدة",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,baseUnit,{{__item.id.product}})"
                    },
                    {
                      "value": "__item.quantity",
                      "text": "Quantity\\nالكمية",
                      "type": "text"
                    },
                    {
                      "value": "__item.id.unitPrice",
                      "text": "Price\\nالسعر",
                      "formula": "fn(HELPER_FN,unitPriceFormat,{{__item.id.unitPrice}})"
                    },
                    {
                      "value": "__item.subTotal",
                      "text": "Sub Total\\nالمجموع الفرعي",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{__variable.quantity}},{{__item.id.unitPrice}}))"
                    },
                    {
                      "value": "__item.vatRate",
                      "text": "VAT %\\nالضريبة %",
                      "type": "formula",
                      "formula": "{{fetchedData.vatPercent}} %"
                    },
                    {
                      "value": "__item.vatValue",
                      "text": "VAT Value\\nقيمة الضريبة",
                      "type": "formula",
                      "formula": "fn(MULTIPLY,{{__variable.quantity}},{{__item.id.unitPrice}},{{fetchedData.vatPercent}},0.01)"
                    },
                    {
                      "value": "__item.total",
                      "text": "Total + VAT\\nالمجموع + الضريبة",
                      "type": "formula",
                      "formula": "fn(MULTIPLY,{{__variable.quantity}},{{__item.id.unitPrice}},fn(SUM,100,{{fetchedData.vatPercent}}),0.01)"
                    },
                    {
                      "value": "__item.actions",
                      "text": "Actions"
                    }
                  ],
                  "tableType": "dynamic",
                  "variableKey": "order",
                  "itemKey": "id._id",
                  "confirmDelete": true,
                  "canDelete": true
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),==,'Return Item'),&&,fn(LOGICAL,fn(LENGTH,{{fetchedData.invOrdersForReturn}}),>,0))"
            },
            {
              "name": "6d-calloffs",
              "pageItems": [
                {
                  "type": "table",
                  "variable": "fetchedData.returnedCalloffOrders",
                  "label": "CN preview MR",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LENGTH,{{fetchedData.invoiceDetails.data.callOffs}}),>,0)",
                  "items": "fetchedData.invOrdersForReturn",
                  "headers": [
                    {
                      "value": "__key",
                      "text": "#",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(SUM,{{__item.__key}},1),/,fn(LENGTH,{{fetchedData.returnedCalloffOrders}}))"
                    },
                    {
                      "value": "__item.orderNo",
                      "text": "Order #\\n# حزمة"
                    },
                    {
                      "value": "__item.callOff.product.alias",
                      "text": "Description\\nالتفاصيل",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,productAlias,{{__item.callOff.product}})"
                    },
                    {
                      "value": "__item.callOff.product.unit2",
                      "text": "Unit\\nالوحدة",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,baseUnit,{{__item.callOff.product}})"
                    },
                    {
                      "value": "__item.quantity",
                      "text": "Quantity\\nالكمية",
                      "type": "text"
                    },
                    {
                      "value": "__item.callOff.unitPrice",
                      "text": "Price\\nالسعر",
                      "formula": "fn(HELPER_FN,unitPriceFormat,{{__item.callOff.unitPrice}})"
                    },
                    {
                      "value": "__item.subTotal",
                      "text": "Sub Total\\nالمجموع الفرعي",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{__variable.quantity}},{{__item.callOff.unitPrice}}))"
                    },
                    {
                      "value": "__item.vatRate",
                      "text": "VAT %\\nالضريبة %",
                      "type": "formula",
                      "formula": "{{fetchedData.vatPercent}} %"
                    },
                    {
                      "value": "__item.vatValue",
                      "text": "VAT Value\\nقيمة الضريبة",
                      "type": "formula",
                      "formula": "fn(MULTIPLY,{{__variable.quantity}},{{__item.callOff.unitPrice}},{{fetchedData.vatPercent}},0.01)"
                    },
                    {
                      "value": "__item.total",
                      "text": "Total + VAT\\nالمجموع + الضريبة",
                      "type": "formula",
                      "formula": "fn(MULTIPLY,{{__variable.quantity}},{{__item.callOff.unitPrice}},fn(SUM,100,{{fetchedData.vatPercent}}),0.01)"
                    },
                    {
                      "value": "__item.actions",
                      "text": "Actions"
                    }
                  ],
                  "tableType": "dynamic",
                  "variableKey": "callOffId",
                  "itemKey": "callOff._id",
                  "confirmDelete": true,
                  "canDelete": true
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),==,'Return Item'),&&,fn(LOGICAL,fn(LENGTH,{{fetchedData.invOrdersForReturn}}),>,0))"
            },
            {
              "name": "7ab",
              "pageItems": [
                {
                  "type": "custom_InvoiceTotal",
                  "variable": "fetchedData.orders",
                  "label": "Sub Total",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.value}}",
                  "config": {
                    "totalFormula": "fn(MULTIPLY,{{fetchedData.value}},fn(SUM,100,{{fetchedData.vatPercent}}),0.01)",
                    "subTotalFormula": "{{fetchedData.value}}",
                    "vatVariable": "{{fetchedData.vatPercent}}"
                  }
                }
              ]
            },
            {
              "name": "7c",
              "pageItems": [
                {
                  "type": "custom_InvoiceTotal",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),==,'Cancelled Invoice'),&&,fn(LOGICAL,fn(LENGTH,{{fetchedData.formattedOrders}}),>,0))",
                  "config": {
                    "totalFormula": "{{fetchedData.invoiceDetails.data.total}}",
                    "subTotalFormula": "{{fetchedData.invoiceDetails.data.subtotal}}",
                    "vatVariable": "{{fetchedData.vatPercent}}"
                  }
                }
              ]
            },
            {
              "name": "7d-orders",
              "pageItems": [
                {
                  "type": "custom_InvoiceTotal",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LENGTH,{{fetchedData.invoiceDetails.data.orders}}),>,0)",
                  "config": {
                    "totalFormula": "fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.quantity}},{{__arrayItem.orderObject.id.unitPrice}},fn(SUM,100,{{fetchedData.vatPercent}}),0.01),{{fetchedData.returnedOrders}},order)",
                    "subTotalFormula": "fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.quantity}},{{__arrayItem.orderObject.id.unitPrice}}),{{fetchedData.returnedOrders}},order)",
                    "vatVariable": "{{fetchedData.vatPercent}}"
                  }
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),==,'Return Item'),&&,fn(LOGICAL,fn(LENGTH,{{fetchedData.invOrdersForReturn}}),>,0))"
            },
            {
              "name": "7d-calloffs",
              "pageItems": [
                {
                  "type": "custom_InvoiceTotal",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LENGTH,{{fetchedData.invoiceDetails.data.callOffs}}),>,0)",
                  "config": {
                    "totalFormula": "fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.quantity}},{{__arrayItem.unitPrice}},fn(SUM,100,{{fetchedData.vatPercent}}),0.01),{{fetchedData.returnedCalloffOrders}},callOffId)",
                    "subTotalFormula": "fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.quantity}},{{__arrayItem.unitPrice}}),{{fetchedData.returnedCalloffOrders}},callOffId)",
                    "vatVariable": "{{fetchedData.vatPercent}}"
                  }
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),==,'Return Item'),&&,fn(LOGICAL,fn(LENGTH,{{fetchedData.invOrdersForReturn}}),>,0))"
            },
            {
              "name": "8ab",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Create Credit Note",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "copyInvoiceId",
                      "executeIf": "fn(LOGICAL,{{fetchedData.selectedInvoice}},>,0)"
                    },
                    {
                      "executionOrder": 1,
                      "name": "copyFormData"
                    },
                    {
                      "executionOrder": 2,
                      "name": "createDiscount"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,{{fetchedData.value}},>,0)",
                  "color": "primary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),==,'Discount'),||,fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),==,'Volume Rebate'))"
            },
            {
              "name": "8c",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Cancel Invoice",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "cancelInvoice"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),==,'Cancelled Invoice'),&&,fn(LOGICAL,fn(LENGTH,{{fetchedData.formattedOrders}}),>,0))",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "8d-orders",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Create Credit Note",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "copyReturnOrdersToForm"
                    },
                    {
                      "executionOrder": 2,
                      "name": "submitReturnItem"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),==,'Return Item'),&&,fn(LOGICAL,fn(LENGTH,{{fetchedData.returnedOrders}}),>,0))",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "8d-calloffs",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Create Credit Note",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "copyCalloffReturnOrdersToForm"
                    },
                    {
                      "executionOrder": 2,
                      "name": "submitReturnItem"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.type}},'),==,'Return Item'),&&,fn(LOGICAL,fn(LENGTH,{{fetchedData.returnedCalloffOrders}}),>,0))",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers?showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers"
        },
        "name": "getCustomers"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCompanyDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=company-detail",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.companyDetails"
        },
        "name": "getCompanyDetails"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCreditNoteReasons",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=credit-note-reasons",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.creditNoteReasons"
        },
        "name": "getCreditNoteReasons"
      },
      {
        "executionOrder": 2,
        "name": "setDefaultValues"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "resetInvoiceSearchFilters",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultFilters",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.invoiceSearch",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "resetInvoiceSearchFilters"
      }
    ],
    "functions": [
      {
        "name": "createDiscount",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/customers/{{fetchedData.selectedCustomer}}/discount",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      },
      {
        "name": "copyCustomerDetails",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.customerDetails"
      },
      {
        "name": "getVatPercentage",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "vatPercent": "fn(CONDITIONAL,{{fetchedData.customerDetails.exportCustomer}},0,{{fetchedData.companyDetails.data.0.data.vatPercentage}})",
          "orders": "[{}]"
        },
        "useFormula": true
      },
      {
        "name": "copyFormData",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getFormData",
        "arg2Key": "destinationKey",
        "arg2Value": "formData",
        "arg3Key": "append",
        "arg3Value": "TRUE",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object"
      },
      {
        "name": "getFormData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "value": "fn(MULTIPLY,{{fetchedData.value}},fn(SUM,100,{{fetchedData.vatPercent}}),0.01)",
          "discountType": "{{fetchedData.type}}"
        },
        "useFormula": true
      },
      {
        "name": "setDefaultValues",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getDefaultValues",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData",
        "arg3Key": "append",
        "arg3Value": "TRUE",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object"
      },
      {
        "name": "getDefaultValues",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "type": "",
          "selectedCustomer": "",
          "value": ""
        },
        "useFormula": true
      },
      {
        "name": "loadStatement",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/report/account-statement/{{fetchedData.selectedCustomer}}?startDate={{fetchedData.startDate}}",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.statement",
        "arg3Key": "fnsAfterSubmit",
        "arg3Value": "pushTotalInvoiceValues"
      },
      {
        "name": "pushTotalInvoiceValues",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getTotalInvoiceValues",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData",
        "arg3Key": "append",
        "arg3Value": "TRUE",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object"
      },
      {
        "name": "getTotalInvoiceValues",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "totalInvoiceValues": "fn(HELPER_FN,getTotalInvoiceValuesFromDateRange,{{fetchedData.statement.data.documents}},{{fetchedData.startDate}},{{fetchedData.endDate}})"
        },
        "useFormula": true
      },
      {
        "name": "updateCreditNoteValue",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getCreditNoteValue",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE"
      },
      {
        "name": "getCreditNoteValue",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "value": "fn(MULTIPLY,{{fetchedData.percent}},{{fetchedData.totalInvoiceValues.0.value}},0.01)"
        },
        "useFormula": true
      },
      {
        "name": "getFormattedOrders",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "formattedOrders": "fn(HELPER_FN,formatOrderForInvoice,{{fetchedData.invoiceDetails.data}},{{fetchedData.vatPercent}})"
        },
        "useFormula": true
      },
      {
        "name": "cancelInvoice",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/invoice/{{fetchedData.selectedInvoice}}/cancel",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      },
      {
        "name": "getFormattedOrdersForReturnItem",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "invOrdersForReturn": "fn(HELPER_FN,mergeInvoiceOrderFg,{{fetchedData.invoiceDetails.data}})"
        },
        "useFormula": true
      },
      {
        "name": "copySelectedOrder",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedOrderData"
      },
      {
        "name": "pushSelectedOrder",
        "type": "fnPushToArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.selectedOrderData",
        "arg2Key": "destinationVariable",
        "arg2Value": "fetchedData.returnedOrders",
        "arg3Key": "sourceTransformationFn",
        "arg3Value": "transformOrderObject"
      },
      {
        "name": "transformOrderObject",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "order": "{{__selectedObject.id._id}}",
          "orderObject": "{{__selectedObject}}",
          "quantity": "fn(HELPER_FN,kgToSellingUnitQuantity,{{__selectedObject.id}},{{__selectedObject.fg}},{{__selectedObject.quantity}})",
          "invValue": "{{__selectedObject.value}}"
        },
        "useFormula": true
      },
      {
        "name": "pushSelectedCalloffOrder",
        "type": "fnPushToArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.selectedOrderData",
        "arg2Key": "destinationVariable",
        "arg2Value": "fetchedData.returnedCalloffOrders",
        "arg3Key": "sourceTransformationFn",
        "arg3Value": "transformCalloffOrderObject"
      },
      {
        "name": "transformCalloffOrderObject",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "order": "{{__selectedObject.orderNo}}",
          "callOffId": "{{__selectedObject.callOff._id}}",
          "unitPrice": "{{__selectedObject.callOff.unitPrice}}",
          "quantity": "{{__selectedObject.quantity}}",
          "invValue": "{{__selectedObject.value}}"
        },
        "useFormula": true
      },
      {
        "name": "copyReturnOrdersToForm",
        "type": "fnCreateArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.returnedOrders",
        "arg2Key": "destinationVariable",
        "arg2Value": "formData.orders",
        "arg3Key": "arrayTransformationFn",
        "arg3Value": "transformReturnOrdersArrayObject"
      },
      {
        "name": "transformReturnOrdersArrayObject",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "id": "{{__selectedObject.order}}",
          "quantity": "fn(HELPER_FN,sellingUnitQuantityToKg,{{__selectedObject.orderObject.fg}},{{__selectedObject.quantity}},{{__selectedObject.orderObject.id.unit.unit2}},{{__selectedObject.orderObject.quantity}},{{__selectedObject.orderObject.id}})",
          "value": "fn(MULTIPLY,{{__selectedObject.quantity}},{{__selectedObject.orderObject.id.unitPrice}})"
        },
        "useFormula": true
      },
      {
        "name": "copyCalloffReturnOrdersToForm",
        "type": "fnCreateArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.returnedCalloffOrders",
        "arg2Key": "destinationVariable",
        "arg2Value": "formData.orders",
        "arg3Key": "arrayTransformationFn",
        "arg3Value": "transformCalloffReturnOrdersArrayObject"
      },
      {
        "name": "transformCalloffReturnOrdersArrayObject",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "id": "{{__selectedObject.order}}",
          "callOffId": "{{__selectedObject.callOffId}}",
          "quantity": "{{__selectedObject.quantity}}",
          "value": "fn(MULTIPLY,{{__selectedObject.quantity}},{{__selectedObject.unitPrice}})"
        },
        "useFormula": true
      },
      {
        "name": "submitReturnItem",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/invoice/{{fetchedData.invoiceDetails.data._id}}/return-item",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      },
      {
        "name": "resetForm",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getDefaultFormValues",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData",
        "arg3Key": "append",
        "arg3Value": "TRUE",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object"
      },
      {
        "name": "getDefaultFormValues",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "selectedCustomer": "",
          "value": 0,
          "selectedInvoice": 0,
          "invOrdersForReturn": "[]",
          "formattedOrders": "[]"
        },
        "useFormula": true
      },
      {
        "name": "copyInvoiceId",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "fetchedData.selectedInvoice",
        "arg2Key": "destinationKey",
        "arg2Value": "formData.invoice"
      },
      {
        "name": "getDefaultFilters",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "q": {
            "status": [ "Approved", "Settled" ]
          },
          "page": 1,
          "limit": 50
        },
        "staticObject": true
      }
    ]
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE",
  "visible": true
}